import { useApiQuery } from 'theSource/utils';
import { AccountDetailResponseDto } from './types';
import { GET_ACCOUNT_DETAILS_QUERY_KEY } from './utils';

export interface UseAccountDetailsProps {
  enabled: boolean;
}

export const useAccountDetailsQuery = ({
  enabled,
}: UseAccountDetailsProps) => {
  return useApiQuery<AccountDetailResponseDto, unknown>({
    queryKey: GET_ACCOUNT_DETAILS_QUERY_KEY,
    endpoint: '/subscriber/account_details',
    showErrorSnackbar: false,
    enabled,
  });
};
